import { Link } from "@tanstack/react-router";
import { TWITTER_URL } from "./SiteHeader";

type FooterLink = { label: string; to?: string; href?: string; external?: boolean };

const FOOTER_COLS: { title: string; links: FooterLink[] }[] = [
  {
    title: "Product",
    links: [
      { label: "Ranking", to: "/app" },
      { label: "How it works", href: "/#how" },
      { label: "Leaderboard", to: "/leaderboard" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Documentation", to: "/docs" },
      { label: "Methodology", href: "/docs#methodology" },
    ],
  },
  {
    title: "Community",
    links: [{ label: "X / Twitter", href: TWITTER_URL, external: true }],
  },
];

const linkClass = "text-[15px] text-ink-soft hover:text-ink hover:underline";
const FALLBACK_BLOCK = 8_412_096;

export function SiteFooter({ lastBlock }: { lastBlock?: number | null }) {
  const block =
    lastBlock != null && lastBlock > 0
      ? lastBlock.toLocaleString("en-US")
      : FALLBACK_BLOCK.toLocaleString("en-US");

  return (
    <footer data-candles className="border-t border-line bg-bg">
      <div className="shell py-12 md:py-16">
        <div className="grid grid-cols-2 gap-x-6 gap-y-10 md:grid-cols-[1.4fr_repeat(3,1fr)] md:gap-12">
          <div className="col-span-2 md:col-span-1">
            <span className="flex w-fit items-center text-[20px] leading-none font-display">
              <span className="text-ink">HOOD</span>
              <span className="bg-accent px-1.5 py-0.5 text-accent-ink">
                RANK
              </span>
            </span>
            <p className="mt-5 max-w-[34ch] text-[15px] text-ink-soft">
              Reputation scoring for X. Powered by Hoodrank. Built on Robinhood chain.
            </p>
          </div>

          {FOOTER_COLS.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <p className="label">{col.title}</p>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    {l.to ? (
                      <Link to={l.to} className={linkClass}>
                        {l.label}
                      </Link>
                    ) : (
                      <a
                        href={l.href}
                        {...(l.external
                          ? { target: "_blank", rel: "noreferrer noopener" }
                          : {})}
                        className={linkClass}
                      >
                        {l.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <hr className="rule mt-10 md:mt-14" />
        <p className="label mt-6 max-w-[52ch] leading-relaxed">
          © 2026 Hoodrank · Scores reflect signal, not truth. DYOR. · Block{" "}
          {block} · Robinhood chain
        </p>
      </div>
    </footer>
  );
}
